// 俄语

export default {
  t1: 'Готово',
  t5: 'Оплатить',
  t6: 'Привязать и авторизовать',
}
